<script setup>
defineProps({
  shift: { type: Object, default: null },
  emptyMessage: { type: String, default: 'Дані відсутні' },
  historical: { type: Boolean, default: false },
})

function dateTime(value, withSeconds = false) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('uk-UA', {
    day: '2-digit', month: '2-digit', year: '2-digit',
    hour: '2-digit', minute: '2-digit', ...(withSeconds ? { second: '2-digit' } : {}),
  }).format(new Date(value))
}

function interval(shift) {
  return `${dateTime(shift?.startedAt, true)} — ${dateTime(shift?.endedAt, true)}`
}
</script>

<template>
  <section class="indicator-section" aria-labelledby="shift-heading">
    <h2 id="shift-heading"><span>01</span> Зміна</h2>
    <div v-if="shift" class="shift-summary dashboard-panel">
      <article><small>{{ historical ? 'Зміна' : 'Поточна зміна' }}</small><strong>№{{ shift?.number ?? '—' }}</strong><span>{{ historical ? interval(shift) : dateTime(shift?.startedAt, true) }}</span></article>
      <article><small>Оператор</small><strong>{{ shift?.operatorName || '—' }}</strong></article>
      <article class="receipt-summary" aria-label="Чеки та повернення"><div><p><span>Чеки</span><strong>{{ shift?.receiptCount ?? '—' }}</strong></p><p><span>Повернення</span><strong>{{ shift?.returnReceiptCount ?? '—' }}</strong></p></div></article>
    </div>
    <p v-else class="dashboard-panel section-unavailable">{{ emptyMessage }}</p>
  </section>
</template>
